export default __webpack_public_path__ + "static/media/CNo.50-1.d5342ce6.jpg";